import { createRouter, createWebHashHistory } from 'vue-router'




const routes = [
  {
    path: '/',
    name: '登录',
    component: () => import('../layout'),
    redirect:'/login',
    children:[
      {
        path: '/index',
        name: '首页',
        component: () => import('../views/index/index.vue')
      },
      {
        path: '/userCenter',
        name: '个人中心',
        component: () => import('../views/userCenter/index.vue')
      },
      {
        path: '/sys/doctor',
        name: '医生管理',
        component: () => import('../views/sys/doctor/index.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})



export default router
